import { useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { tipsDb } from '../../lib/db/index.js';
import { searchByFields } from '../../lib/utils/search.js';
import { PageHeader } from '../../components/shared/PageHeader.js';
import { TipRow } from '../../components/rows/TipRow.js';
import { EmptyState } from '../../components/shared/EmptyState.js';
import { Spinner } from '../../components/shared/Spinner.js';
import { Icon } from '../../components/shared/Icon.js';

export function TipsPage() {
  const [, setParams] = useSearchParams();
  const [search, setSearch] = useState('');
  const q = useQuery({
    queryKey: ['tips', 'shared'],
    queryFn: () => tipsDb.findShared({ count: 200 }),
  });
  const filtered = useMemo(() => {
    if (!q.data) return [];
    return searchByFields(q.data, search, ['title', 'body']);
  }, [q.data, search]);

  return (
    <div className="page">
      <PageHeader
        eyebrow="03 · TIPS"
        title="TIPS"
        subtitle="ベストプラクティス・ハウツーを短文で蓄積する。検証メモから昇格した知見も歓迎。"
        actions={
          <button
            type="button"
            className="btn primary sm"
            onClick={() => setParams({ compose: 'tip' })}
          >
            <Icon name="plus" size={13} />
            TIPS を書く
          </button>
        }
      />

      <div style={{ padding: '14px 0 0' }}>
        <input
          type="search"
          placeholder="タイトル・本文で検索"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="list-search"
        />
      </div>

      {q.isPending && <Spinner />}
      {q.data && filtered.length === 0 && <EmptyState title="該当する TIPS はありません" />}

      {filtered.length > 0 && (
        <div style={{ borderTop: '1px solid var(--line)', marginTop: 14 }}>
          {filtered.map((t) => (
            <TipRow key={t.id} tip={t} />
          ))}
        </div>
      )}
    </div>
  );
}
